<template>
  <div v-if="page">
    <page-banner
      :title="page.banner.title"
      :text="page.banner.text"
      :colour="page.banner.colour"
    />
    <div class="grid-x align-center">
      <div class="cell small-11 medium-10">
        <v-content :blocks="page.content"/>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapState, mapMutations, mapGetters } from 'vuex';
  import PageBanner from '@/components/PageBanner.vue';
  import VContent from '@/components/content/Content.vue';

  export default {
    metaInfo() {
      return {
        title: 'Useful Resources'
      }
    },
    components: {
      PageBanner,
      VContent
    },
    props: {
      homeSlug: String
    },
    data() {
      return {
        currentCategory: 'all',
        currentPage: 1
      }
    },
    mounted() {
      this.fetchPage('useful-resources')
        .then(() => {
          this.fetchCategories()
          this.grabUsefulResourcesPage();
        });
    },
    methods: {
      ...mapActions([
        'fetchPage',
        'fetchCategories',
        'fetchUsefulResourcesPage'
      ]),
      ...mapMutations([
        'clearUsefulResourcesPages'
      ]),
      grabUsefulResourcesPage() {
        this.fetchUsefulResourcesPage({
          home: this.homeSlug,
          page: this.currentPage,
          category: this.currentCategory
        })
      },
      changePage() {
        this.grabUsefulResourcesPage();
      }
    },
    computed: {
      ...mapState(['categories', 'home']),
      ...mapGetters({
        maxPages: 'getUsefulResourcesMaxPages'
      }),
      page() {
        return this.$store.getters.getPage('useful-resources');
      },
      items() {
        return this.$store.getters.getUsefulResourcesPage(this.currentPage);
      }
    },
    watch: {
      currentCategory() {
        this.clearUsefulResourcesPages();
        this.currentPage = 1;
        this.grabUsefulResourcesPage();
      }
    }
  }
</script>

<style lang="scss" scoped>
  .title {
    margin-bottom: 1em;
  }
</style>
